export default __webpack_public_path__ + "bdb475cd90ae1125bd0e1fc6fcfd73d8.png";